import React from 'react';
import {Button, Intent, ProgressBar} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {formatDate} from '../../../../utils/date';

import './ResultRunning.scss';

interface ResultRunningProps {
  result: any;
  pending?: boolean;
  onCancelExecution?: (blockUid: string, key: string) => void;
  key?: any;
}

const CancelButton = ({onCancel}: any) => (
  <Button
    text="Cancel"
    onClick={onCancel}
    icon={IconNames.SYMBOL_SQUARE}
  />
);

export const ResultRunning = ({
  result,
  pending = false,
  onCancelExecution,
}: ResultRunningProps) => {
  /*
   * Running or Pending
   */
  const {start_time} = result;

  return (
    <div className="result-running">
      <div className="result-running__content">
        <ProgressBar intent={Intent.NONE}/>
        {
          !pending && (
            <div className="result-running__content__details">
              <div>Execution started at <strong>{formatDate(start_time)}</strong></div>
            </div>
          )
        }
        {onCancelExecution && <CancelButton onCancel={onCancelExecution}/>}
      </div>
    </div>
  )
}
